import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Fallback to http://localhost:8000 if REACT_APP_BACKEND_URL is not set or empty
export const API = `${process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000'}/api`;

export const AFFILIATE_LABELS = {
  bol: 'Bol.com',
  amazon: 'Amazon.nl',
  coolblue: 'Coolblue',
};

export const AFFILIATE_COLORS = {
  bol: 'bg-[#0000A4] text-white hover:bg-[#00007a]',
  amazon: 'bg-[#FF9900] text-black hover:bg-[#e68900]',
  coolblue: 'bg-[#0090E3] text-white hover:bg-[#0076bf]',
};

export function formatPrice(n) {
  return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(n);
}
